// Main stylesheet (extracted by Vite into css/app.css)
import '../css/app.css';
import 'litelight-js/css';
import { init as initLightbox } from 'litelight-js';
initLightbox();


import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.start()

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import AOS from 'aos';

AOS.init({
  once: true,
});

const swiper = new Swiper('.reviewsSlider', {
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 32,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    640: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // when window width is >= 480px
    1280: {
      slidesPerView: 3,
      spaceBetween: 30
    }
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
